import { Entity } from "../common-models/Entity";

export class FrontVersion extends Entity {
  number: number;
  numberName: string;
  description: string;
  createdAt: Date;
  mandatory: boolean;
  active: boolean;
}

export const FrontVersionResources = {
  currentNumber: 382,
  currentNumberName: '3.82',
  improvements: [
    'Adiciona na home, para o perfil Admin, a tela Administrar Lojas, com a lista de lojas e filtros por nome ou ID Shopify, omnichannel, uso do Sislog e comunicação transacional.',
    'Permite cadastrar uma nova loja com as informações obrigatórias e ver o detalhe de cada loja com todas as informações.',
    'Permite editar o contato, o e-mail e o horário de funcionamento da loja e habilitar a comunicação transacional a partir de uma data e hora.',
  ]
}
